export enum AuthenticationState {
  UNAUTHENTICATED,
  AUTHENTICATED,
  ROLE_SPECIFICATION_REQUIRED,
}
